(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var header_search = ( function( $ ) {

	var $header_utils;
	var $container;

	var _init = function() {
		$header_utils = $( '.header-utils' );
		$container    = $( '#header-search-container' );

		$header_utils.find( 'a#header-search-link' ).on( 'click', _toggle_search );
		$container.find( 'a.close-header-search' ).on( 'click', _toggle_search );
	};

	var _toggle_search = function( e ) {
		e.preventDefault();

		$container.slideToggle();

		$container.toggleClass( 'open' );
		$header_utils.find( 'a#header-search-link' ).toggleClass( 'open' );
	};

	if ( $( '#header-search-container' ).length > 0 ) {
		$( document ).ready( _init );
	}

} ) ( jQuery );

module.exports = header_search;
},{}],2:[function(require,module,exports){
require('./js/header-search.js');
},{"./js/header-search.js":1}]},{},[2]);
